import { memo, useState } from 'react'
import { useSelector } from 'react-redux'

import { dispatch } from 'store'
import { aiLibSelectors } from 'store/features/aiLibVideo/selectors'
import { aiLibThunks } from 'store/features/aiLibVideo/thunks'
import { aiLibImageSelectors } from 'store/features/aiLibImage/selectors'
import { aiLibImageThunks } from 'store/features/aiLibImage/thunks'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import Filter from 'assets/svgr-icons/filter.svg'

import { TabKeys } from '../consts'
import FiltersFlyout from '../FiltersFlyout'
import VideoFiltersSection from '../VideosTab/FiltersSection'
import ImageFiltersSection from '../ImagesTab/FiltersSection'
import * as Styled from './styled'

const FilterTrigger = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const activeTab = useSelector(aiLibSelectors.activeTab)
  const isVideos = activeTab === TabKeys.VIDEOS

  const videoIsOpen = useSelector(aiLibSelectors.isFiltersOpen)
  const videoHasActiveFilters = useSelector(aiLibSelectors.hasActiveFilters)
  const imageIsOpen = useSelector(aiLibImageSelectors.isFiltersOpen)
  const imageHasActiveFilters = useSelector(
    aiLibImageSelectors.hasActiveFilters
  )

  const isOpen = isVideos ? videoIsOpen : imageIsOpen
  const hasActiveFilters = isVideos
    ? videoHasActiveFilters
    : imageHasActiveFilters

  const handleToggle = () => {
    dispatch(aiLibThunks.toggleFiltersOpen())
    dispatch(aiLibImageThunks.toggleFiltersOpen())
  }

  const handleClose = () => {
    dispatch(aiLibThunks.closeFilters())
    dispatch(aiLibImageThunks.closeFilters())
  }

  const handleClearAll = () => {
    dispatch(
      isVideos ? aiLibThunks.resetFilters() : aiLibImageThunks.resetFilters()
    )
  }

  return (
    <>
      <Styled.FilterIconButton
        ref={setAnchorEl}
        type="button"
        aria-label={translate(T.FILTER_LABEL)}
        $isActive={isOpen}
        onClick={handleToggle}
      >
        <Filter />
        {hasActiveFilters ? <Styled.ActiveDot /> : null}
      </Styled.FilterIconButton>

      <FiltersFlyout
        isOpen={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        hasActiveFilters={hasActiveFilters}
        onClearAll={handleClearAll}
      >
        {isVideos ? <VideoFiltersSection /> : <ImageFiltersSection />}
      </FiltersFlyout>
    </>
  )
}

export default memo(FilterTrigger)
